import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import rollbar from '~/vendor/rollbar';

import {deserializeQuoteWidget} from '~/data/deserializers/quote';

import {postHeaders, rfeCredentialsHeader} from '~/utils/http';

import {URLS} from '~/constants/QuoteConstants';

const transformQuoteWidgetResponse = response => {
  if (response?.wcibmo) return response;
  return deserializeQuoteWidget(response?.json?.() || response);
};

const transformQuoteWidgetErrorResponse = response => {
  if (response?.error) {
    rollbar.warn('External Service Failure: quoteWidgetApi:', response.error);
  }
};

export const quoteWidgetApi = createApi({
  reducerPath: 'quoteWidgetApi',
  baseQuery: fetchBaseQuery({
    ...postHeaders,
    baseUrl: URLS.quoting,
    credentials: rfeCredentialsHeader
  }),
  endpoints: builder => ({
    // https://github.com/customink/rails-frontend/blob/ee410dfdbaefe43cd93e4e6e1f44f7d51d430f5f/app/controllers/pricing_controller.rb#L79-L105
    getQuoteWidgetDeserialized: builder.query({
      query: ({config}) => {
        // productColorId and productQtySizes are used along with 'config' as keys for the caching mechanism.
        // The idea is to avoid undetected changes in the serialized values of config from preventing a necessary new request.
        return {
          url: '/',
          method: 'POST',
          body: config
        };
      },
      transformResponse: transformQuoteWidgetResponse,
      transformErrorResponse: transformQuoteWidgetErrorResponse
    }),
    // skip deserialization
    getQuoteWidget: builder.query({
      query: ({config}) => {
        return {
          url: '/',
          method: 'POST',
          body: config
        };
      },
      transformErrorResponse: transformQuoteWidgetErrorResponse
    })
  })
});

export const {
  useGetQuoteWidgetQuery,
  useGetQuoteWidgetDeserializedQuery,
  endpoints: quoteWidgetEndpoints
} = quoteWidgetApi;
